import type {
  ArrayExpression,
  BooleanExpression,
  DynamicValue,
  Expression,
  NumberExpression,
  StringExpression,
} from '@wirechunk/schemas/expressions/expression.d.ts';

export type ExpressionOperator = Expression['operator'];

export const ExpressionType = {
  Array: 'Array',
  Boolean: 'Boolean',
  Number: 'Number',
  String: 'String',
} as const;

export type ExpressionType = keyof typeof ExpressionType;

const dynamicValueOperators: Array<DynamicValue['operator']> = ['dataValue', 'prop'];

export const arrayOperators: Array<ArrayExpression['operator']> = [
  'arrayLiteral',
  'filter',
  'map',
  'userProductItems',
  ...dynamicValueOperators,
];

export const booleanOperators: Array<BooleanExpression['operator']> = [
  'all',
  'arrayIncludes',
  'booleanLiteral',
  'both',
  'either',
  'equals',
  'exists',
  'greaterThan',
  'not',
  'some',
  ...dynamicValueOperators,
];

export const numberOperators: Array<NumberExpression['operator']> = [
  'currentTime',
  'length',
  'numberLiteral',
  'sum',
  'sumArray',
  'timeLiteral',
  ...dynamicValueOperators,
];

export const stringOperators: Array<StringExpression['operator']> = [
  'eventType',
  'stringLiteral',
  'userRole',
  ...dynamicValueOperators,
];

export const isArrayOperator = (
  operator: ExpressionOperator,
): operator is ArrayExpression['operator'] => arrayOperators.includes(operator as never);

export const isBooleanOperator = (
  operator: ExpressionOperator,
): operator is BooleanExpression['operator'] => booleanOperators.includes(operator as never);

export const isNumberOperator = (
  operator: ExpressionOperator,
): operator is NumberExpression['operator'] => numberOperators.includes(operator as never);

export const isStringOperator = (
  operator: ExpressionOperator,
): operator is StringExpression['operator'] => stringOperators.includes(operator as never);
